export default {
    VALIDAR_DOCUMENTO_VIRTUALIZADO: 'validarDocumentoVirtualizado',
    BAIXAR_DOCUMENTOS_VIRTUALIZADOS: 'baixarDocumentosVirtualizados',
    BUSCAR_COMPRAS_DIRETAS_PUBLICAS: 'buscarComprasDiretasPublicas',
    BUSCAR_ITENS_E_LOTES: 'buscarItensELotes',
    BUSCAR_DADOS_GERAIS_PUBLICO: 'buscarDadosGeraisPublico',
    BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA: 'baixarRelatorioDaAtaDaCompraDireta',
    DOWNLOAD_ANEXO: 'downloadAnexo',
    BAIXAR_DOCUMENTO_VIRTUALIZADO: 'baixarDocumentoVirtualizado',
    BUSCAR_DOCUMENTOS_SOLICITADOS: 'buscarDocumentosSolicitados',
    BUSCAR_DOCUMENTOS_PROPOSTA: 'buscarDocumentosProposta',
    BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA: 'buscarLinhasDeFornecimentoDaCompraDireta',
    BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS: 'buscarResultadoDeTodosLotesEItensDoFornecedor',
    BUSCAR_USUARIO_LOGADO: 'buscarUsuarioLogado',
    BUSCAR_PRODUTO_POR_NOME: 'buscarProdutoPorNome',

}
